// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutPaymentDetailsStyles } from "@bg/Overrides/Widgets/OnePageCheckout/OnePageCheckoutPaymentDetails";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import xScreen from "@bg/XDL/Utilities/xScreen";
import { css } from "styled-components";

onePageCheckoutPaymentDetailsStyles.paymentDetailsGridContainer = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px 60px;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentDetailsHeadingText = {
    variant: "h3",
    css: css`
        grid-column: 1/3;
        margin-bottom: 0;
        ${xScreen("lte", "md")} {
            grid-column: initial;
        }
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentMethodAndPONumberContainer = {
    css: css`
        display: grid;
        grid-template-columns: 1fr;
        gap: 32px;
    `,
};

onePageCheckoutPaymentDetailsStyles.enterPromotionCodeGridItem = {
    css: css`
        position: relative;
        width: 100%;
    `,
};

onePageCheckoutPaymentDetailsStyles.enterPromotionCodeApplyButton = {
    variant: "secondary",
    sizeVariant: "small",
    css: css`
        position: absolute;
        right: 4px;
        top: 30px;
    `,
};

onePageCheckoutPaymentDetailsStyles.creditCardDetails = {
    creditCardDetailsHeading: {
        variant: "h5",
    },
    expirationMonthGridItemOnePageCheckout: {
        width: 6,
    },
    expirationYearGridItemOnePageCheckout: {
        width: 6,
    },
    securityCodeGridItem: {
        width: 6,
        css: css`
            padding-right: 10px;
        `,
    },
    securityCodeTokenExFrame: {
        cssOverrides: {
            descriptionWrapper: css`
                &&&&&& {
                    margin: 0;
                }
            `,
        },
    },
    securityCodeText: {
        cssOverrides: {
            descriptionWrapper: css`
                &&&&&& {
                    margin: 0;
                }
            `,
        },
    },
};

onePageCheckoutPaymentDetailsStyles.promotionTagsGridContainerItem = {
    css: css`
        margin-top: 8px;
    `,
};

onePageCheckoutPaymentDetailsStyles.promotionTagsGridItem = {
    css: css`
        margin-bottom: 20px;
    `,
};

onePageCheckoutPaymentDetailsStyles.promotionSuccess = {
    color: "success",
    lineHeight: fontConfig.lineHeight.singleLinexSmall,
    css: css`
        margin-top: 8px;
        max-width: 100%;
    `,
};

onePageCheckoutPaymentDetailsStyles.removeCodesLink = {
    color: "primary",
    css: css`
        margin-top: 5px;
    `,
};

onePageCheckoutPaymentDetailsStyles.promotionCodeTag = {
    typographyProps: {
        ellipsis: true,
        css: css`
            width: 100%;
            text-align: left;
            margin: 5px 0;
            padding-right: 5px;
        `,
    },
    css: css`
        width: fit-content;
        align-items: center;
        & > button {
            min-height: 0;
        }
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentMethodGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 5px;
    `,
};

onePageCheckoutPaymentDetailsStyles.paymentProfileEditCardLink = {
    css: css`
        margin-left: 16px;
        white-space: nowrap;
    `,
};

onePageCheckoutPaymentDetailsStyles.savedPaymentProfileContainer = {
    css: css`
        max-width: calc(50% - 10px);
    `,
};
